function addClassContext(items = [], classTag = {}) {
  return items.map((item) => {
    const subject = item.subject || 'General';

    return {
      ...item,
      class_tag_id: classTag.tag_id,
      class_tag_name: classTag.tag_name,
      class_subject: classTag.subject || subject,
      subject: classTag.tag_name ? `${subject} · ${classTag.tag_name}` : subject,
    };
  });
}

function compareByDateThenSubject(left, right) {
  const leftDate = String(left.deadline || left.record_date || '');
  const rightDate = String(right.deadline || right.record_date || '');
  return leftDate.localeCompare(rightDate)
    || String(left.subject || '').localeCompare(String(right.subject || ''));
}

export function mergeClassDashboards(dashboards = []) {
  const merged = dashboards.reduce((result, dashboard) => {
    const classTag = dashboard.class_tag || {};
    result.assignments.push(...addClassContext(dashboard.assignments, classTag));
    result.due_today.push(...addClassContext(dashboard.due_today, classTag));
    result.upcoming.push(...addClassContext(dashboard.upcoming, classTag));
    if (dashboard.class_tag) result.class_tags.push(dashboard.class_tag);
    return result;
  }, {
    assignments: [],
    due_today: [],
    upcoming: [],
    class_tags: [],
  });

  merged.due_today.sort(compareByDateThenSubject);
  merged.upcoming.sort(compareByDateThenSubject);
  return merged;
}
